const boxParams = {
  title: {
    type: 'input',
    maxLength: 10,
    default: '热销商品',
    placeholder: '请输入主标题',
    label: '模块标题'
  },
  subTitle: {
    type: 'input',
    maxLength: 15,
    default: 'Hot Sales',
    placeholder: '请输入副标题',
    label: '模块描述'
  },
  showHeader: {
    type: 'switch',
    default: false,
    label: '显示头部',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showMore: {
    type: 'switch',
    default: true,
    label: '显示更多',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  icon: {
    type: 'image',
    default: 'http://s3.zhifu88.cn/zhifu/461320220629141108.png',
    label: '模块图标',
  },
  showIcon: {
    type: 'switch',
    default: true,
    label: '显示图标',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
}
const boxStyle = {
  // showTopBorder: {
  //   type: 'switch',
  //   default: true,
  //   label: '顶部边距',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showRightBorder: {
  //   type: 'switch',
  //   default: true,
  //   label: '右侧边距',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showBottomBorder: {
  //   type: 'switch',
  //   default: true,
  //   label: '底部边距',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showLeftBorder: {
  //   type: 'switch',
  //   default: true,
  //   label: '左侧边距',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showTopPadding: {
  //   type: 'switch',
  //   default: true,
  //   label: '顶部填充',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showRightPadding: {
  //   type: 'switch',
  //   default: true,
  //   label: '右侧填充',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showBottomPadding: {
  //   type: 'switch',
  //   default: true,
  //   label: '底部填充',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showLeftPadding: {
  //   type: 'switch',
  //   default: true,
  //   label: '左侧填充',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // showBorderRadius: {
  //   type: 'switch',
  //   default: false,
  //   label: '圆角边框',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // boxType: {
  //   type: 'radio',
  //   default: 'card',
  //   label: '背景样式',
  //   valueTemplate: {
  //     card: '立体',
  //     block: '扁平'
  //   }
  // },
  // backgroundColor: {
  //   type: 'color',
  //   default: 'rgba(248, 248, 248,1)',
  //   label: '背景色'
  // },
  layoutType: {
    type: 'radio',
    default: '1row1column',
    label: '排列样式',
    valueTemplate: {
      '1row1column': '一行一列',
      '1row2column': '一行两列',
      '1rowNcolumn': '一行多列'
    }
  },
  // itemBoxType: {
  //   type: 'radio',
  //   default: 'card',
  //   label: '图块样式',
  //   valueTemplate: {
  //     card: '立体',
  //     block: '扁平'
  //   }
  // },
  // itemShowBorderRadius: {
  //   type: 'switch',
  //   default: false,
  //   label: '图块圆角',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // itemImgShowBorderRadius: {
  //   type: 'switch',
  //   default: false,
  //   label: '图片圆角',
  //   valueTemplate: {
  //     false: '否',
  //     true: '是'
  //   }
  // },
  // itemBackgroundColor: {
  //   type: 'color',
  //   default: 'rgba(248, 248, 248,1)',
  //   label: '图块颜色'
  // },
}
const treOneStyle = {
  showTopBorder: {
    type: 'switch',
    default: true,
    label: '顶部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightBorder: {
    type: 'switch',
    default: true,
    label: '右侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomBorder: {
    type: 'switch',
    default: true,
    label: '底部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftBorder: {
    type: 'switch',
    default: true,
    label: '左侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showTopPadding: {
    type: 'switch',
    default: true,
    label: '顶部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightPadding: {
    type: 'switch',
    default: true,
    label: '右侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomPadding: {
    type: 'switch',
    default: true,
    label: '底部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftPadding: {
    type: 'switch',
    default: true,
    label: '左侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBorderRadius: {
    type: 'switch',
    default: true,
    label: '圆角边框',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showImgBorderRadius: {
    type: 'switch',
    default: true,
    label: '图片圆角',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  backgroundColor: {
    type: 'color',
    default: 'rgba(255,255,255,1)',
    label: '背景色'
  },
  boxType: {
    type: 'radio',
    default: 'card',
    label: '背景样式',
    valueTemplate: {
      card: '立体',
      block: '扁平'
    }
  },
}
const treTwoStyle = {
  showTopBorder: {
    type: 'switch',
    default: true,
    label: '顶部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightBorder: {
    type: 'switch',
    default: true,
    label: '右侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomBorder: {
    type: 'switch',
    default: true,
    label: '底部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftBorder: {
    type: 'switch',
    default: true,
    label: '左侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showTopPadding: {
    type: 'switch',
    default: true,
    label: '顶部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightPadding: {
    type: 'switch',
    default: true,
    label: '右侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomPadding: {
    type: 'switch',
    default: true,
    label: '底部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftPadding: {
    type: 'switch',
    default: true,
    label: '左侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showSpace: {
    type: 'switch',
    default: true,
    label: '显示间隔',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBorderRadius: {
    type: 'switch',
    default: true,
    label: '圆角边框',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showImgBorderRadius: {
    type: 'switch',
    default: true,
    label: '图片圆角',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  backgroundColor: {
    type: 'color',
    default: 'rgba(255,255,255,1)',
    label: '背景色'
  },
  boxType: {
    type: 'radio',
    default: 'card',
    label: '背景样式',
    valueTemplate: {
      card: '立体',
      block: '扁平'
    }
  },
}
const treMoreStyle = {
  showTopBorder: {
    type: 'switch',
    default: true,
    label: '顶部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightBorder: {
    type: 'switch',
    default: true,
    label: '右侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomBorder: {
    type: 'switch',
    default: true,
    label: '底部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftBorder: {
    type: 'switch',
    default: true,
    label: '左侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showTopPadding: {
    type: 'switch',
    default: true,
    label: '顶部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightPadding: {
    type: 'switch',
    default: true,
    label: '右侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomPadding: {
    type: 'switch',
    default: true,
    label: '底部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftPadding: {
    type: 'switch',
    default: true,
    label: '左侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showSpace: {
    type: 'switch',
    default: true,
    label: '显示间隔',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBorderRadius: {
    type: 'switch',
    default: true,
    label: '圆角边框',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showImgBorderRadius: {
    type: 'switch',
    default: true,
    label: '图片圆角',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  backgroundColor: {
    type: 'color',
    default: 'rgba(255,255,255,1)',
    label: '背景色'
  },
  boxType: {
    type: 'radio',
    default: 'card',
    label: '背景样式',
    valueTemplate: {
      card: '立体',
      block: '扁平'
    }
  },
}
const imgMoreStyle = {
  showTopBorder: {
    type: 'switch',
    default: true,
    label: '顶部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightBorder: {
    type: 'switch',
    default: true,
    label: '右侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomBorder: {
    type: 'switch',
    default: true,
    label: '底部边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftBorder: {
    type: 'switch',
    default: true,
    label: '左侧边距',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showTopPadding: {
    type: 'switch',
    default: true,
    label: '顶部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showRightPadding: {
    type: 'switch',
    default: true,
    label: '右侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBottomPadding: {
    type: 'switch',
    default: true,
    label: '底部填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showLeftPadding: {
    type: 'switch',
    default: true,
    label: '左侧填充',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showSpace: {
    type: 'switch',
    default: true,
    label: '显示间隔',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showBorderRadius: {
    type: 'switch',
    default: true,
    label: '圆角边框',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  showImgBorderRadius: {
    type: 'switch',
    default: true,
    label: '图片圆角',
    valueTemplate: {
      false: '否',
      true: '是'
    }
  },
  backgroundColor: {
    type: 'color',
    default: 'rgba(255,255,255,1)',
    label: '背景色'
  },
  boxType: {
    type: 'radio',
    default: 'card',
    label: '背景样式',
    valueTemplate: {
      card: '立体',
      block: '扁平'
    }
  },
}
const navOptions = [
  {
    src: 'http://s3.zhifu88.cn/zhifu/629020220629142553.png',
    name: '商品分类',
    navTo: '/pages/category/category'
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/529020220629142447.png',
    name: '商城订单',
    navTo: '/pages/order/order',
  },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/529020220629142447.png',
  //   name: '课程订单',
  //   navTo: '/onlinePages/order/order',
  // },
  // {
  //   src: 'https://res.zhifu88.cn/alachuang/65920200508202828/order.png',
  //   name: '直播列表',
  //   navTo: '/onlinePages/live/list',
  // },
  // {
  //   src: 'https://res.zhifu88.cn/alachuang/668620200508202828/collect.png',
  //   name: '直播详情',
  //   navTo: '/onlinePages/live/live',
  //   query: {
  //     type: 'live',
  //     paramName: 'id'
  //   }
  // },
  // {
  //   src: 'https://res.zhifu88.cn/alachuang/976720200509113338/category_course.png',
  //   name: '课程分类',
  //   navTo: '/onlinePages/category/category',
  // },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '课程详情',
  //   navTo: '/onlinePages/course/course',
  //   query: {
  //     type: 'course',
  //     paramName: 'id'
  //   }
  // },
  {
    src: 'http://s3.zhifu88.cn/zhifu/615020220629142447.png',
    name: '商品收藏',
    navTo: '/pages/collect/list',
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '商品列表',
    navTo: '/pages/product/list?type=1',
    // navTo: '/pages/search/search',
    query: {
      type: 'shopCategory',
      category:'goods',
      paramName: ['tid']
    }
  },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '课程列表',
  //   navTo: '/onlinePages/source/source',
  //   query: {
  //     type: 'courseCategory',
  //     category:'course',
  //     paramName: ['tid']
  //   }
  // },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '商品详情',
    navTo: '/pages/product/product?type=1',
    query: {
      type: 'product',
      paramName: 'id'
    }
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '线上商品',
    navTo: '/pages/product/product?type=3',
    query: {
      type: 'virtual',
      paramName: 'id'
    }
  },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '数字商品',
  //   navTo: '/onlinePages/course/course',
  //   query: {
  //     type: 'courseVideo',
  //     paramName: 'id'
  //   }
  // },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '课程详情',
  //   navTo: '/pages/product/product',
  //   query: {
  //     type: 'course',
  //     paramName: 'id'
  //   }
  // },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '购物车',
    navTo: '/pages/cart/cart'
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '收货地址列表',
    navTo: '/pages/address/address'
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '个人信息',
    navTo: '/pages/userinfo/userinfo'
  },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '积分纪录',
  //   navTo: '/pages/pointLog/pointLog'
  // },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '我的直播',
  //   navTo: '/onlinePages/myLive/myLive'
  // },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '搜索',
    navTo: '/pages/product/list?type=1',
    query: {
      type: 'shopCategory',
      category:'goods',
      paramName: ['tid']
    }
  },
  {
    src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
    name: '团购列表',
    navTo: '/pages/product/list?type=4'
  },
  // {
  //   src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
  //   name: '资源列表',
  //   navTo: '/onlinePages/source/source',
  //   query: {
  //     type: 'courseCategory',
  //     paramName: ['tid']
  //   }
  // }
]

export default {
  'swiper-search': {
    code: 'swiper-search',
    title: '搜索轮播图设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {
      placeholder: {
        type: 'input',
        maxLength: 10,
        default: '请输入关键字搜索',
        placeholder: '请输入搜索描述',
        label: '提示文字'
      }
    },
    data: {
      type: 'list',
      maxLength: false,
      childType: 'image',
      options: navOptions,
      params: {
        title: false,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   dotType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '指示器样式',
    //     valueTemplate: {
    //       1: '样式1',
    //       2: '样式2',
    //       3: '样式3'
    //     }
    //   }
    // }
  },
  'search': {
    code: 'search',
    title: '搜索轮播图设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {
      placeholder: {
        type: 'input',
        maxLength: 10,
        default: '请输入关键字搜索',
        placeholder: '请输入搜索描述',
        label: '提示文字'
      },
      inputBackgroundColor: {
        type: 'color',
        default: 'rgba(248, 248, 248,1)',
        label: '输入框色'
      },
      placeholderColor: {
        type: 'color',
        default: 'rgba(149, 149, 149,1)',
        label: '字体颜色'
      },
      showImage: {
        type: 'switch',
        default: true,
        label: '显示图片',
        valueTemplate: {
          false: '否',
          true: '是'
        }
      },
    },
    data: {
      type: 'obj',
      childType: 'image',
      params: {
        title: false,
        subTitle: false
      },
      template: {
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    // }
  },
  'nav': {
    code: 'nav',
    title: '导航栏设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'list',
      maxLength: false,
      childType: 'nav',
      template: [
        {
          src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
          name: '导航1',
          navTo: '/onlinePages/category/category'
        }
      ],
      options: navOptions,
      params: {
        title: true,
      },
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   showType: {
    //     type: 'radio',
    //     default: 'flex-row',
    //     label: '排列方式',
    //     valueTemplate: {
    //       'flex-row': '自动折行',
    //       'scroll': '横向滚动'
    //     }
    //   },
    //   imgType: {
    //     type: 'radio',
    //     default: 'small',
    //     label: '图标类型',
    //     valueTemplate: {
    //       'big': '大图',
    //       'small': '小图'
    //     }
    //   },
    //   circle: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆形图标',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   titleColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '标题颜色'
    //   },
    //   num: {
    //     type: 'inputNumber',
    //     min: 1,
    //     max: 5,
    //     default: 5,
    //     placeholder: '请输入每行数量',
    //     label: '每行数量'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    // }
  },
  'swiper': {
    code: 'swiper',
    title: '轮播图设置',
    subTitle: '建议尺寸高375px 宽750px，图片支持png，jpg格式，大小不超过3M',
    params: false,
    data: {
      type: 'list',
      maxLength: false,
      childType: 'image',
      linkPage: true,
      options: navOptions,
      params: {
        title: false,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   dotType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '指示器样式',
    //     valueTemplate: {
    //       1: '样式1',
    //       2: '样式2',
    //       3: '样式3'
    //     }
    //   }
    // }
  },
  'img-one': {
    code: 'img-one',
    title: '单图设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj',
      childType: 'image',
      options: navOptions,
      params: {
        title: false,
      },
      template: {
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }
    },
    style: {
      // showTopBorder: {
      //   type: 'switch',
      //   default: true,
      //   label: '顶部边距',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showRightBorder: {
      //   type: 'switch',
      //   default: true,
      //   label: '右侧边距',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showBottomBorder: {
      //   type: 'switch',
      //   default: true,
      //   label: '底部边距',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showLeftBorder: {
      //   type: 'switch',
      //   default: true,
      //   label: '左侧边距',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showTopPadding: {
      //   type: 'switch',
      //   default: true,
      //   label: '顶部填充',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showRightPadding: {
      //   type: 'switch',
      //   default: true,
      //   label: '右侧填充',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showBottomPadding: {
      //   type: 'switch',
      //   default: true,
      //   label: '底部填充',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showLeftPadding: {
      //   type: 'switch',
      //   default: true,
      //   label: '左侧填充',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showBorderRadius: {
      //   type: 'switch',
      //   default: true,
      //   label: '圆角边框',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // showImgBorderRadius: {
      //   type: 'switch',
      //   default: true,
      //   label: '图片圆角',
      //   valueTemplate: {
      //     false: '否',
      //     true: '是'
      //   }
      // },
      // backgroundColor: {
      //   type: 'color',
      //   default: 'rgba(255,255,255,1)',
      //   label: '背景色'
      // },
      // boxType: {
      //   type: 'radio',
      //   default: 'card',
      //   label: '背景样式',
      //   valueTemplate: {
      //     card: '立体',
      //     block: '扁平'
      //   }
      // },
    }
  },
  'img-two': {
    code: 'img-two',
    title: '双图设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'list',
      maxLength: 2,
      childType: 'image',
      options: navOptions,
      params: {
        title: false,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showSpace: {
    //     type: 'switch',
    //     default: true,
    //     label: '显示间隔',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showImgBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '图片圆角',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    // }
  },
  'img-more': {
    code: 'img-more',
    title: '多图设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'list',
      maxLength: false,
      childType: 'image',
      options: navOptions,
      params: {
        title: false,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: imgMoreStyle
  },
  'friend': {
    code: 'friend',
    title: '友情链接设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {
      title: {
        type: 'input',
        maxLength: 10,
        default: '友情链接',
        placeholder: '请输入标题',
        label: '模块标题'
      }
    },
    data: {
      type: 'list',
      maxLength: false,
      childType: 'image',
      options: navOptions,
      params: {
        title: false,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   imageBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '图片圆角',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   }
    // }
  },
  'box-product': {
    code: 'box',
    title: '商品栏配置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: boxParams,
    data: {
      type: 'obj_list',
      childType: 'product',
      maxLength: false,
      changeLength: true
    },
    style: boxStyle
  },
  'box-audio': {
    code: 'box',
    title: '商品栏配置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: boxParams,
    data: {
      type: 'obj_list',
      childType: 'courseAudio',
      maxLength: false,
      changeLength: true
    },
    style: boxStyle
  },
  'box-video': {
    code: 'box',
    title: '商品栏配置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: boxParams,
    data: {
      type: 'obj_list',
      childType: 'courseVideo',
      maxLength: false,
      changeLength: true
    },
    style: boxStyle
  },
  'box-image': {
    code: 'box',
    title: '商品栏配置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: boxParams,
    data: {
      type: 'obj_list',
      childType: 'courseImage',
      maxLength: false,
      changeLength: true
    },
    style: boxStyle
  },
  'box-live': {
    code: 'box',
    title: '商品栏配置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: boxParams,
    data: {
      type: 'obj_list',
      childType: 'live',
      maxLength: false,
      changeLength: true
    },
    style: boxStyle
  },
  'tre-one-product': {
    code: 'tre-one',
    title: '单商品设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_obj',
      childType: 'product',
    },
    // style: treOneStyle
  },

  'tre-one-video': {
    code: 'tre-one',
    title: '单视频设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_obj',
      childType: 'courseVideo'
    },
    // style: treOneStyle
  },

  'tre-one-audio': {
    code: 'tre-one',
    title: '单资源设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_obj',
      childType: 'courseAudio',
    },
    // style: treOneStyle
  },

  'tre-one-image': {
    code: 'tre-one',
    title: '单图文设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_obj',
      childType: 'courseImage',
    },
    // style: treOneStyle
  },

  // 'tre-one-live': {
  //   code: 'tre-one',
  //   title: '单直播设置',
  //   subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
  //   params: false,
  //   data: {
  //     type: 'obj_obj',
  //     childType: 'live',
  //   },
  //   style: treOneStyle
  // },
  'tre-two-product': {
    code: 'tre-two',
    title: '双商品设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'product',
      maxLength: 2,
      changeLength: false
    },
    // style: treTwoStyle
  },
  'tre-two-video': {
    code: 'tre-two',
    title: '双视频设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseVideo',
      maxLength: 2,
      changeLength: false
    },
    // style: treTwoStyle
  },
  'tre-two-audio': {
    code: 'tre-two',
    title: '双音频设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseAudio',
      maxLength: 2,
      changeLength: false
    },
    // style: treTwoStyle
  },
  'tre-two-image': {
    code: 'tre-two',
    title: '双资源设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseImage',
      maxLength: 2,
      changeLength: false
    },
    // style: treTwoStyle
  },
  // 'tre-two-live': {
  //   code: 'tre-two',
  //   title: '双直播设置',
  //   subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
  //   params: false,
  //   data: {
  //     type: 'obj_list',
  //     childType: 'live',
  //     maxLength: 2,
  //     changeLength: false
  //   },
  //   style: treTwoStyle
  // },
  'tre-more-product': {
    code: 'tre-more',
    title: '多商品设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'product',
      maxLength: false,
      changeLength: true
    },
    // style: treMoreStyle
  },
  'tre-more-video': {
    code: 'tre-more',
    title: '多视频设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseVideo',
      maxLength: false,
      changeLength: true
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   showPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '显示边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    // }
  },
  'tre-more-audio': {
    code: 'tre-more',
    title: '多音频设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseAudio',
      maxLength: false,
      changeLength: true
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   showPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '显示边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    // }
  },
  'tre-more-image': {
    code: 'tre-more',
    title: '多图文设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj_list',
      childType: 'courseImage',
      maxLength: false,
      changeLength: true
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   showPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '显示边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    // }
  },
  // 'tre-more-live': {
  //   code: 'tre-more',
  //   title: '多直播设置',
  //   subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
  //   params: false,
  //   data: {
  //     type: 'obj_list',
  //     childType: 'live',
  //     maxLength: false,
  //     changeLength: true
  //   },
  //   style: {
  //     showTopBorder: {
  //       type: 'switch',
  //       default: true,
  //       label: '顶部边距',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //     showRightBorder: {
  //       type: 'switch',
  //       default: true,
  //       label: '右侧边距',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //     showBottomBorder: {
  //       type: 'switch',
  //       default: true,
  //       label: '底部边距',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //     showLeftBorder: {
  //       type: 'switch',
  //       default: true,
  //       label: '左侧边距',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //     showBorderRadius: {
  //       type: 'switch',
  //       default: true,
  //       label: '圆角边框',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //     boxType: {
  //       type: 'radio',
  //       default: 'card',
  //       label: '背景样式',
  //       valueTemplate: {
  //         card: '立体',
  //         block: '扁平'
  //       }
  //     },
  //     showPadding: {
  //       type: 'switch',
  //       default: true,
  //       label: '显示边距',
  //       valueTemplate: {
  //         false: '否',
  //         true: '是'
  //       }
  //     },
  //   }
  // },
  'header': {
    code: 'header',
    title: '标题模块设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {
      title: {
        type: 'input',
        maxLength: 10,
        default: '热销商品',
        placeholder: '请输入主标题',
        label: '模块标题'
      },
      subTitle: {
        type: 'input',
        maxLength: 15,
        default: 'Hot Sales',
        placeholder: '请输入副标题',
        label: '模块描述'
      },
      showMore: {
        type: 'switch',
        default: true,
        label: '显示更多',
        valueTemplate: {
          false: '否',
          true: '是'
        }
      },
      icon: {
        type: 'image',
        default: 'http://s3.zhifu88.cn/zhifu/461320220629141108.png',
        label: '模块图标',
      },
      showIcon: {
        type: 'switch',
        default: true,
        label: '显示图标',
        valueTemplate: {
          false: '否',
          true: '是'
        }
      }
    },
    data: {
      type: 'obj',
      childType: 'link',
      maxLength: 1,
      template: {
        name: '商品分类',
        navTo: '/pages/category/category'
      },
      options: [
        {
          name: '商品分类',
          navTo: '/pages/category/category'
        },
        {
          name: '订单中心',
          navTo: '/pages/order/order?state=0'
        },
        // {
        //   name: '直播',
        //   navTo: '/onlinePages/live/list'
        // },
        {
          name: '课程分类',
          navTo: '/onlinePages/category/category'
        },
        {
          name: '商品收藏',
          navTo: '/pages/collect/list'
        }
      ]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '背景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   }
    // }
  },
  'open': {
    code: 'open',
    title: '公众号设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {
      title: {
        type: 'input',
        maxLength: 10,
        default: '公众号名称',
        placeholder: '请输入标题',
        label: '标题名称'
      },
      subTitle: {
        type: 'input',
        maxLength: 100,
        inputType: 'textarea',
        default: 'Hot Sales',
        placeholder: '请输入文字简介',
        label: '文字简介'
      },
      icon: {
        type: 'image',
        default: 'https://res.zhifu88.cn/alachuang/854020200508211355/hot.png',
        label: '头像图片',
      }
    },
    data: false,
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   }
    // }
  },
  'video': {
    code: 'video',
    title: '视频播放器',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {

    },
    data: {
      type: 'obj',
      childType: 'video',
      maxLength: false,
      changeLength: true
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   }
    // }
  },
  'swiper-card': {
    code: 'swiper-card',
    title: '滑动卡片',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {

    },
    data: {
      type: 'list',
      childType: 'obj_list',
      childTemplate: {
        type: 'image',
        title: '课程',
        subTitle: '',
        list: []
      },
      childParams: {
        title: true,
        subTitle: false,
        img: false
      },
      maxLength: 5,
      childMaxLength: 3,
      changeLength: true,
      childChangeLength: true,
      childOptions: navOptions,
      childTypeOptions: [
        {
          label: '图片',
          value: 'image'
        },
        {
          label: '视频',
          value: 'video'
        }
      ]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },

    //   titleColor: {
    //     type: 'color',
    //     default: 'rgba(0, 0, 0,1)',
    //     label: '标题颜色'
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '背景色'
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   cardBackgroundColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '卡片背景色'
    //   },
    // }
  },
  'swiper-card2': {
    code: 'swiper-card2',
    title: '滑动卡片',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {

    },
    data: {
      type: 'list',
      childType: 'obj_list',
      childTemplate: {
        type: 'image',
        title: '课程',
        subTitle: '',
        list: []
      },
      childParams: {
        title: false,
        subTitle: false,
        img: true
      },
      maxLength: 5,
      childMaxLength: 3,
      changeLength: true,
      childChangeLength: true,
      childOptions: navOptions,
      childTypeOptions: [
        {
          label: '图片',
          value: 'image'
        },
        {
          label: '视频',
          value: 'video'
        }
      ]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },

    //   titleColor: {
    //     type: 'color',
    //     default: 'rgba(0, 0, 0,1)',
    //     label: '标题颜色'
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '背景色'
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: false,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   cardBackgroundColor: {
    //     type: 'color',
    //     default: 'rgba(248, 248, 248,1)',
    //     label: '卡片背景色'
    //   },
    // }
  },
  'recommend': {
    code: 'recommend',
    title: '商品推荐',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: {

    },
    data: {
      type: 'list',
      childType: 'obj_list',
      childTemplate: {
        type: 'product',
        title: '课程',
        subTitle: '',
        list: []
      },
      childParams: {
        title: true,
        subTitle: true
      },
      maxLength: 2,
      childMaxLength: 2,
      changeLength: false,
      childChangeLength: true,
      childOptions: navOptions,
      childTypeOptions: [
        {
          label: '图片',
          value: 'image'
        }
      ]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showSpace: {
    //     type: 'switch',
    //     default: true,
    //     label: '显示间隔',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showImgBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '图片圆角',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    //   cardBackgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '卡片背景'
    //   },
    // }
  },
  'swiper-lrregular': {
    code: 'swiper-lrregular',
    title: '推荐1设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'list',
      maxLength: 2,
      childType: 'image',
      options: navOptions,
      params: {
        title: true,
      },
      template: [{
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }]
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showImgBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '图片圆角',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    // }
  },
  'img-text': {
    code: 'img-text',
    title: '半图半文设置',
    subTitle: '图标名称不超过5个字，更换图标要求尺寸1:1，限50k以内',
    params: false,
    data: {
      type: 'obj',
      childType: 'image',
      options: navOptions,
      params: {
        title: true,
        subTitle: true,
      },
      template: {
        title: '',
        subTitle: '',
        src: 'http://s3.zhifu88.cn/zhifu/783020220629140758.png',
        navTo: 'https://www.baidu.com'
      }
    },
    // style: {
    //   showTopBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftBorder: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧边距',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showTopPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '顶部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showRightPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '右侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBottomPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '底部填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showLeftPadding: {
    //     type: 'switch',
    //     default: true,
    //     label: '左侧填充',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '圆角边框',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   showImgBorderRadius: {
    //     type: 'switch',
    //     default: true,
    //     label: '图片圆角',
    //     valueTemplate: {
    //       false: '否',
    //       true: '是'
    //     }
    //   },
    //   backgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '背景色'
    //   },
    //   cardBackgroundColor: {
    //     type: 'color',
    //     default: 'rgba(255,255,255,1)',
    //     label: '前景色'
    //   },
    //   boxType: {
    //     type: 'radio',
    //     default: 'card',
    //     label: '背景样式',
    //     valueTemplate: {
    //       card: '立体',
    //       block: '扁平'
    //     }
    //   },
    // }
  },
}
